(() => {
  if (window.searchDrawerCarouselReady) return;
  window.searchDrawerCarouselReady = true;

  const CAROUSEL_SELECTOR = '.search-drawer__product-carousel';
  const SPACE_BETWEEN = 4;

  const readOffset = (root) => parseFloat(getComputedStyle(root).getPropertyValue('--drawer-body-padding-inline')) || 0;

  const create = (root) => {
    if (root.dataset.swiperReady) return;
    root.dataset.swiperReady = 'true';

    const controls = root.closest('.floating-controls-container');
    const prevEl = controls?.querySelector('.search-drawer__nav--prev');
    const nextEl = controls?.querySelector('.search-drawer__nav--next');

    // 箭头显隐沿用主题的 [disabled] 样式，不走 swiper 自己的 class
    const syncNav = (swiper) => {
      if (prevEl) prevEl.disabled = swiper.isLocked || swiper.isBeginning;
      if (nextEl) nextEl.disabled = swiper.isLocked || swiper.isEnd;
    };

    const offset = readOffset(root);

    new Swiper(root, {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: SPACE_BETWEEN,
      slidesOffsetBefore: offset,
      slidesOffsetAfter: offset,
      loop: false,
      watchOverflow: true,
      resistanceRatio: 0.85,
      observer: true,
      observeParents: true,
      navigation: { prevEl: prevEl, nextEl: nextEl },
      mousewheel: { forceToAxis: true, releaseOnEdges: true },
      on: {
        init: syncNav,
        slideChange: syncNav,
        fromEdge: syncNav,
        toEdge: syncNav,
        lock: syncNav,
        unlock: syncNav,
        update: syncNav,
        resize: (swiper) => {
          const current = readOffset(root);
          swiper.params.slidesOffsetBefore = current;
          swiper.params.slidesOffsetAfter = current;
          syncNav(swiper);
        },
      },
    });
  };

  // 抽屉关着时宽度为 0，swiper 会按 0 宽算 slide，等真正显示出来再初始化
  const initWhenVisible = (root) => {
    if (root.dataset.swiperReady || root.dataset.swiperPending) return;

    if (root.clientWidth > 0) {
      create(root);
      return;
    }

    root.dataset.swiperPending = 'true';

    const observer = new ResizeObserver(() => {
      if (root.clientWidth === 0) return;

      observer.disconnect();
      delete root.dataset.swiperPending;
      create(root);
    });

    observer.observe(root);
  };

  let retries = 0;
  let scanQueued = false;

  const scan = () => {
    scanQueued = false;

    if (typeof Swiper === 'undefined') {
      if (retries < 40) {
        retries += 1;
        setTimeout(scan, 50);
      }
      return;
    }

    retries = 0;
    document.querySelectorAll(CAROUSEL_SELECTOR).forEach(initWhenVisible);
  };

  const queueScan = () => {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(scan);
  };

  const observeInjectedResults = () => {
    const predictiveSearch = document.getElementById('predictive-search');
    if (!predictiveSearch) return;

    // 无结果时的推荐位是搜索过程中才从 template 注入的
    new MutationObserver(queueScan).observe(predictiveSearch, { childList: true, subtree: true });
  };

  const start = () => {
    observeInjectedResults();
    scan();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
